
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import xhr from './../../../../../utils/xhr';
import categoriesApi from './../../../../../api/Categories.api';
import reduxStore from './../../../../../reduxStore';
import Spinnable from './../../../../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper.jsx';
import EditEntityExperianCheck from './../../../../../pages/EditThirdParty/components/EditEntityExperianCheck.jsx';
import { userHas, permissions} from "../../../../../permissions";

class EntityInformation extends React.Component {

    static propTypes = {
        companyData: PropTypes.object,
        experianData: PropTypes.object
    }

    static defaultProps = {
        experianData: null
    }

    constructor(props) {
        super(props);

        this.state = {
            companyData: this.props.companyData,
            categories : this.props.companyData.categoryIds,
            categoryStore: {}
        };

        this.generateCategoryOptions = this.generateCategoryOptions.bind(this);
        this.generateCategoryLabels = this.generateCategoryLabels.bind(this);
    }

    componentWillMount() {
        this.props.spinner.showSpinner();
        categoriesApi
            .getCategoryNames()
            .then((categoryStore) => {
                this.setState({categoryStore: categoryStore});
                this.props.spinner.hideSpinner();
            }).catch((error) => {
            this.props.spinner.hideSpinner();
            xhr.handleAllErrors(error);
        });
    }

    generateCategoryOptions() {
        let categoryStore = this.state.categoryStore;

        let categoryOptions = [];
        for (let categoryId in categoryStore) {
            if (categoryStore.hasOwnProperty(categoryId)) {
                categoryOptions.push(
                    <option key={'category-option-' + categoryId} value={categoryId}>
                        {categoryStore[categoryId]}
                    </option>
                );
            }
        }
        return categoryOptions;
    }

    generateCategoryLabels() {
        let categoryLabels = [];
        let categoryIds = this.state.categories;
        let categoryStore = this.state.categoryStore;

        if (categoryIds && categoryStore) {
            for (let i = 0; i < categoryIds.length; i++) {
                let categoryId   = categoryIds[i],
                    categoryName = categoryStore[categoryId];

                if (categoryId && categoryName) {
                    categoryLabels.push(
                        <span className="tags-label notranslate" title={categoryName} key={'category-label-' + i}>
                            {categoryName}
                        </span>
                    );
                }
            }
        }

        return categoryLabels;
    }


    render() {
        let user = reduxStore.getState().user;
        let categoryLabels = this.generateCategoryLabels();

        return (

            <div className="entity-information">
                {
                    this.state.companyData.uniqueThirdPartyId ?
                        <div className="entity-information__entity-id">
                            <div className="entity-information__entity-id--title">
                                <FormattedMessage
                                    id="Dashboard_SingleView_UIText_aboutThisEntity_entityId" />
                            </div>

                            <div className="entity-information__entity-id--data">
                                {this.state.companyData.uniqueThirdPartyId}
                            </div>

                        </div>
                        :
                        null
                }

                {
                    this.state.companyData.dunsNumber ?
                        <div className="entity-information__entity-duns">
                            <div className="entity-information__entity-duns--title">
                                <FormattedMessage
                                    id="Dashboard_SingleView_UIText_aboutThisEntity_duns" />
                            </div>
                            <div className="entity-information__entity-duns--data">
                                {this.state.companyData.dunsNumber}
                            </div>
                        </div>
                        :
                        null
                }

                {
                    this.state.companyData.experianBusinessId ?
                        <div className="entity-information__entity-experian-id">

                            <div className="entity-information__entity-experian-id--title">
                                <FormattedMessage
                                    id="Dashboard_SingleView_UIText_aboutThisEntity_experian" />
                            </div>

                            <div className="entity-information__entity-experian-id--data">
                                {this.state.companyData.experianBusinessId}
                                {user.appSettings.isExperianEnabled && this.props.experianData && (
                                    <EditEntityExperianCheck
                                        autorun={true}
                                        experian={this.state.companyData.experianBusinessId}
                                        experianResponse={this.props.experianData.experianResponse}
                                        checkExperian={(e) => {}}
                                    />
                                )}
                            </div>
                        </div>
                        :
                        null
                }

                {
                    this.state.companyData.entityUrl ?
                        <div className="entity-information__entity-url">

                            <div className="entity-information__entity-url--title">
                                <FormattedMessage
                                    id="Dashboard_SingleView_UIText_aboutThisEntity_url" />
                            </div>

                            <div className="entity-information__entity-url--data">
                                {this.state.companyData.entityUrl}
                            </div>

                        </div>
                        :
                        null
                }
                {
                    categoryLabels.length ? (
                        <div className="entity-information__entity-categories">

                            <div className="entity-information__entity-categories--title">
                                <FormattedMessage
                                    id="Dashboard_SingleView_UIText_aboutThisEntity_categories" />
                            </div>

                            <div className="entity-information__entity-categories--data">
                                {categoryLabels}
                            </div>

                        </div>
                    ) : null
                }

                <div className="entity-information__entity-edit">
                    {userHas(permissions.entities.edit) &&
                    <Link
                        className="action-link"
                        to={'edit-third-party/' + this.state.companyData.id + '/?backRoute=entity-dashboard'}>
                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.panel.editCompany" />
                    </Link>
                    }

                </div>
            </div>
        );
    }

}

export default Spinnable(EntityInformation);


// WEBPACK FOOTER //
// ./src/scripts/pages/EntityDashboard/components/AboutThisEntity/components/EntityInformation.jsx